module.exports = __webpack_public_path__ + "img/a2-s60.29dd7c73.jpg";